import type { ReactNode } from 'react';
import { HelpCircle } from 'lucide-react';

/**
 * Hover/focus-triggered tooltip. There is no popover/portal library in this
 * project (no Radix/Headless UI), so this is a plain group-hover Tailwind
 * bubble rather than a positioned-portal component - fine for the short,
 * single-line hints it's used for so far.
 */
export function Tooltip({ content, children }: { content: ReactNode; children: ReactNode }) {
  return (
    <span className="group relative inline-flex items-center">
      {children}
      <span
        role="tooltip"
        className="pointer-events-none absolute bottom-full left-1/2 z-10 mb-2 w-max max-w-xs -translate-x-1/2 rounded-control border border-line-strong bg-surface-3 px-2.5 py-1.5 text-center text-xs font-medium text-fg opacity-0 shadow-card transition-opacity duration-fast group-focus-within:opacity-100 group-hover:opacity-100"
      >
        {content}
      </span>
    </span>
  );
}

/** Small "?" hint icon with a tooltip - drop next to a label to explain something non-obvious. */
export function InfoHint({ text }: { text: ReactNode }) {
  return (
    <Tooltip content={text}>
      <button
        type="button"
        aria-label="Pomoč"
        className="inline-flex rounded-full text-fg-muted transition-colors duration-fast hover:text-fg-secondary"
      >
        <HelpCircle size={14} aria-hidden="true" />
      </button>
    </Tooltip>
  );
}
